import { Grid, Typography } from '@mui/material'
import React from 'react'

export const ExtendEventError: React.FC = () => {
  return (
    <Grid container item xs={12} style={{ marginBottom: 20 }}>
      <Typography variant="h4">
        You can only extend Booking related events.
      </Typography>
    </Grid>
  )
}
